import PrimaryButton from '@components/atoms/buttons/PrimaryButton';
import Section from 'components/atoms/Section';
import { Heading2 } from 'components/atoms/Typography';
import { openHelpDeskChat } from '@lib/helpers/chat';
import { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled(Section)`
  p {
    max-width: 490px;
    margin: 32px 0;
  }
`;

const TalkWithUsSection: FC = () => (
  <Wrapper>
    <div className="quote-resume-margin">
      <Heading2>Dúvidas?</Heading2>
      <p>
        Teremos o maior prazer em explicar seu contrato de seguro e como a Luna
        trabalha em detalhes com você.
      </p>
      <PrimaryButton onClick={openHelpDeskChat}>
        Fale Conosco
      </PrimaryButton>
    </div>
  </Wrapper>
);

export default TalkWithUsSection;
